// extracted by mini-css-extract-plugin
export var icon = "_7-1";
export var subtext = "_7-0";